import React from 'react';
import { useAuth0, Auth0Provider } from '@auth0/auth0-react';
import { useInvalidateCredentials, Token, s2Token, CachedTokenProvider } from '@seabrookstudios/auth';
import { useQuery } from '@tanstack/react-query';

const useLogout = () => {
  const { logout: auth0Logout } = useAuth0();
  const invalidateCreds = useInvalidateCredentials();

  const logout = async () => {
    await auth0Logout({ logoutParams: { federated: true } });
    await invalidateCreds();
  };

  return logout;
};

const useCachedCredentials = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: Token,
    queryFn: async () => {
      const token = s2Token(await getAccessTokenSilently());
      if (token === undefined) {
        return null;
      }

      return token;
    },
    staleTime: 2592000 * 1000,
  });
};

const _jsxFileName = "/Users/seabrookstudios/projects/seabrook-studios/packages/@seabrookstudios/auth-web/src/Auth0Stack.jsx";
/**
 * @param {import('@auth0/auth0-react').AppState} appState
 */
const onRedirectCallback = (appState) => {
  // @ts-expect-error history is global in web
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : // @ts-expect-error window is global in web
        window.location.pathname
  );
};

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {string} props.domain
 * @param {string} props.clientId
 * @param {string} props.audience
 */
const Auth0Stack = ({ domain, clientId, audience, children }) => {
  return (
    React.createElement(Auth0Provider, {
      domain: domain,
      clientId: clientId,
      cacheLocation: "localstorage",
      useRefreshTokens: true,
      // onRedirectCallback: onRedirectCallback,
      authorizationParams: {
        audience,
        // @ts-expect-error window is global in web
        redirect_uri: window.location.origin,
      }, __self: undefined, __source: {fileName: _jsxFileName, lineNumber: 28}}

      , React.createElement(CachedTokenProvider, { useCachedCredentials: useCachedCredentials, __self: undefined, __source: {fileName: _jsxFileName, lineNumber: 40}}
        , children
      )
    )
  );
};

export { Auth0Stack, useCachedCredentials, useLogout };
